import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/agriculture/AgricultureClient.tsx");
